<ion-button (click)="onClick()">
  <br />
  <ion-icon ios="filter" md="filter" slot="icon-only"></ion-icon>
</ion-button>
